@let name = ariaLabel();

<!-- Named vs decorative. Material stamps `role="progressbar"` and `tabindex="-1"`
     on the spinner's host, and a progressbar with no accessible name is reported
     as a defect by screen readers. So a spinner the server named is announced
     with that name, and an unnamed one is hidden from assistive tech outright —
     with its tabindex stripped too, so the hidden node isn't focusable (an
     aria-hidden element that can still take focus is its own violation). Same
     treatment the image component gives its own load spinner. -->
<mat-spinner [attr.aria-label]="name ?? null" [attr.aria-hidden]="name ? null : 'true'" [attr.tabindex]="name ? -1 : null" />
